import { render } from "./VersionPublishOverlay.vue?vue&type=template&id=39311e14&scoped=true&ts=true"
import script from "./VersionPublishOverlay.vue?vue&type=script&lang=ts"
export * from "./VersionPublishOverlay.vue?vue&type=script&lang=ts"

import "./VersionPublishOverlay.vue?vue&type=style&index=0&id=39311e14&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39311e14"]])

export default __exports__